// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_10-0";
export var colorSwatch = "_10-5";
export var fillWidth = "_10-4";
export var iconButton = "_10-2";
export var iconWrapper = "_10-3";
export var shadow = "_10-6";
export var xs = "_10-1";